import './Header.scss';
import Logo from '../../assets/Logo.png';
import cn from 'classnames';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Header = ({ onFormClick }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const [isServicesOpen, setServicesOpen] = useState(false);

  const handleScroll = () => {
    setIsMenuOpen(false);
  };

  const handleWindowSizeChange = () => {
    setIsMobile(window.innerWidth <= 1200);
  };

  useEffect(() => {
    setIsMobile(window.innerWidth <= 1200);
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleWindowSizeChange);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  const renderHeaderLinks = () => {
    return (
      <>
        <div className='headerLinks'>
          <span
            onClick={() => {
              setIsMenuOpen(false);
              navigate('/');
            }}
            className={cn('headerLink', window.location.pathname === '/' && 'headerLinkActive')}
          >
            Home
          </span>
          <span
            onClick={() => {
              setServicesOpen(!isServicesOpen);
            }}
            className={cn('headerLink', window.location.pathname === '/services' && 'headerLinkActive')}
          >
            Services
          </span>
          {isServicesOpen && (
            <div className='servicesList'>
              <span
                className='servicesListItem'
                onClick={() => {
                  setIsMenuOpen(false);
                  setServicesOpen(!isServicesOpen);
                  navigate('/services');
                }}
              >
                All Services
              </span>
              <span
                className='servicesListItem'
                onClick={() => {
                  setIsMenuOpen(false);
                  setServicesOpen(!isServicesOpen);
                  navigate('/staffing_solutions');
                }}
              >
                Staffing Solutions
              </span>
              <span
                className='servicesListItem'
                onClick={() => {
                  setIsMenuOpen(false);
                  setServicesOpen(!isServicesOpen);
                  navigate('/raas');
                }}
              >
                Recruitment-As-A-Service
              </span>
              <span
                className='servicesListItem'
                onClick={() => {
                  setIsMenuOpen(false);
                  setServicesOpen(!isServicesOpen);
                  window.open('https://ndleadershippartners.com/', '_blank');
                }}
              >
                Leadership Partners
              </span>
            </div>
          )}
          <span
            onClick={() => {
              setIsMenuOpen(false);
              navigate('/about');
            }}
            className={cn('headerLink', window.location.pathname === '/about' && 'headerLinkActive')}
          >
            About
          </span>
          <span
            onClick={() => {
              setIsMenuOpen(false);
              navigate('/blog');
            }}
            className={cn('headerLink', window.location.pathname === '/blog' && 'headerLinkActive')}
          >
            Blog
          </span>
          <span
            onClick={() => {
              setIsMenuOpen(false);
              navigate('/jobs');
            }}
            className={cn('headerLink', window.location.pathname.includes('/jobs') && 'headerLinkActive')}
          >
            Jobs
          </span>
          {/* <span
            onClick={() => {
              setIsMenuOpen(false);
              navigate('/work-with-us');
            }}
            className={cn('headerLink', window.location.pathname === '/work-with-us' && 'headerLinkActive')}
          >
            Work With Us
          </span> */}
        </div>
        <span className='headerContact' onClick={onFormClick}>
          Find Next Great Hire
          <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
              d='M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96452 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7473 9.41498 20.7192 6.93661 18.8913 5.10872C17.0634 3.28084 14.585 2.25273 12 2.25ZM16.2806 12.5306L13.2806 15.5306C13.1399 15.6714 12.949 15.7504 12.75 15.7504C12.551 15.7504 12.3601 15.6714 12.2194 15.5306C12.0786 15.3899 11.9996 15.199 11.9996 15C11.9996 14.801 12.0786 14.6101 12.2194 14.4694L13.9397 12.75H8.25C8.05109 12.75 7.86033 12.671 7.71967 12.5303C7.57902 12.3897 7.5 12.1989 7.5 12C7.5 11.8011 7.57902 11.6103 7.71967 11.4697C7.86033 11.329 8.05109 11.25 8.25 11.25H13.9397L12.2194 9.53063C12.0786 9.3899 11.9996 9.19902 11.9996 9C11.9996 8.80098 12.0786 8.61011 12.2194 8.46938C12.3601 8.32864 12.551 8.24958 12.75 8.24958C12.949 8.24958 13.1399 8.32864 13.2806 8.46938L16.2806 11.4694C16.3504 11.539 16.4057 11.6217 16.4434 11.7128C16.4812 11.8038 16.5006 11.9014 16.5006 12C16.5006 12.0986 16.4812 12.1962 16.4434 12.2872C16.4057 12.3783 16.3504 12.461 16.2806 12.5306Z'
              fill='#3ABC83'
            />
          </svg>
        </span>
      </>
    );
  };

  return (
    <div className='header'>
      <div className='headerContent'>
        <div className='headerLogo' onClick={() => navigate('/')}>
          <img src={Logo} alt='Logo' />
        </div>
        {isMobile ? (
          <span className='headerMenu' onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? (
              <svg width='24' height='24' viewBox='0 0 24 24' fill='none'>
                <path d='M18 6L6 18' stroke='#8C8B9A' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
                <path d='M6 6L18 18' stroke='#8C8B9A' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
              </svg>
            ) : (
              <svg width='24' height='24' viewBox='0 0 24 24' fill='none'>
                <path d='M3 12H21' stroke='#8C8B9A' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
                <path d='M3 6H21' stroke='#8C8B9A' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
                <path d='M3 18H21' stroke='#8C8B9A' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
              </svg>
            )}
          </span>
        ) : (
          renderHeaderLinks()
        )}
      </div>
      {isMenuOpen && <div className='phoneHeaderMenu'>{renderHeaderLinks()}</div>}
    </div>
  );
};

export default Header;
